import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";

const container: CSSProperties = {};

const searchButton: CSSProperties = {
  display: "flex",
  alignItems: "center",
  color: colors.green.darker,
  cursor: "pointer",
  padding: "20px 35px 20px 5px",
};

const searchIconButton: CSSProperties = {
  color: colors.green.darker,
};

const searchButtonText: CSSProperties = {
  marginLeft: 5,
  fontWeight: "bold",
};

const searchInput: CSSProperties = {
  padding: "10px 14px",
};

const results: CSSProperties = {
  "& .no-results": {
    textAlign: "center",
    padding: 20,
  },
};

const teamSizeWarning: CSSProperties = {
  display: "flex",
  alignItems: "center",
  margin: "15px 12px",
};

const warningIcon: CSSProperties = {
  color: colors.peach.darker,
  marginRight: 5,
  width: 16,
};

const warningLabel: CSSProperties = {
  flexGrow: 1,
  fontSize: 12,
  color: colors.peach.darker,
  paddingTop: 2,
};

export const styles = {
  container,
  searchButton,
  searchIconButton,
  searchButtonText,
  searchInput,
  results,
  teamSizeWarning,
  warningIcon,
  warningLabel,
};
